import {
	SET_ENTITIES,
	SET_ENTITY,
	CLEAR_ENTITIES,
	CLEAR_ENTITY,
	ADD_ENTITY,
	UPDATE_ENTITY,
	REMOVE_ENTITY,
} from './actionTypes';

export const entity = (state = {}, action) => {
	switch (action.type) {
		case SET_ENTITY:
			return action.payload;
		case UPDATE_ENTITY:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_ENTITY:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_ENTITIES:
			return action.payload;
		case ADD_ENTITY:
			return [...state, action.payload];
		case UPDATE_ENTITY:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_ENTITY:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_ENTITIES:
			return [];
		default:
			return state;
	}
};
